const $slideshow = $('.section-three-images-wrapper');

function imagesSlider() {
    $slideshow.slick({
        dots: true,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 600,
        autoplay: true,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 770,
                settings: 'unslick'
            }
        ]
    });
}

$(document).ready(function() {
    imagesSlider();
});

$(window).resize(function(){
    imagesSlider();
});
